import Page from '@components/Page/Page'
import SeatingArea from '@components/seatingArea/SeatingArea'
import { TableUrlParams, useTableUrlSync } from '@hooks/useTableUrlSync'
import { SeatingArea as SeatingAreaModel } from '@models/SeatingArea'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  getSeatingAreas,
  selectSeatingAreas,
  setSeatingAreaQuery,
} from '@store/SeatingAreaReducer'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { SBRM, SBRMAction, useSBRM } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Permission } from '@utils/permissions'
import type { TableColumnsType } from 'antd'
import { useEffect } from 'react'

const SeatingAreasPage = () => {
  const { isOpen } = useSBRM()
  const dispatch = useAppDispatch()
  const seatingAreas = useAppSelector(selectSeatingAreas())
  const { query, isLoading } = useAppSelector((state) => state.seatingArea)

  const columns: TableColumnsType<SeatingAreaModel> = [
    {
      title: 'Avatar',
      render: (record: SeatingAreaModel) => (
        <SeatingArea.Avatar model={record} />
      ),
    },
    {
      align: 'right',
      render: (record: SeatingAreaModel) => (
        <SBRM.Actions
          actions={[SBRMAction.Update]}
          entity={Entity.seatingArea}
          entityId={record.id}
        />
      ),
    },
  ]

  const fetchSeatingAreas = (params: TableUrlParams) => {
    const newQuery: TableParams = {
      ...query,
      pagination: {
        ...query.pagination,
        current: params.page,
        pageSize: params.pageSize,
      },
    }

    dispatch(setSeatingAreaQuery(newQuery))
    dispatch(getSeatingAreas(newQuery))
  }

  const { handleTableChange, params } = useTableUrlSync<SeatingAreaModel>({
    onParamsChange: fetchSeatingAreas,
  })

  useEffect(() => {
    if (isOpen) {
      return
    }

    fetchSeatingAreas(params)
  }, [isOpen])

  return (
    <Page
      permissions={Permission.listSeatingArea}
      pageTitle={{
        title: 'Seating areas',
        level: 4,
        toolbar: (
          <SBRM.Actions
            actions={[SBRMAction.Create]}
            entity={Entity.seatingArea}
          />
        ),
      }}
    >
      <SBTable
        columns={columns}
        dataSource={seatingAreas}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={query.pagination}
      />
    </Page>
  )
}

export default SeatingAreasPage
